import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { ToastContainer } from "react-toastify";

import Login from './auth/Login';
import Register from './auth/Register';
import Header from './panel/Header';
import Menu from './panel/Menu';
import Footer from './panel/Footer';

import Dashboard from './components/Dashboard';
import Forgetpass from './auth/Forgetpass';
import Disabled from './panel/Disabled';
import Uploaddocuments from './panel/Uploaddocuments';
import Notfound from './panel/Notfound';

import Course from './components/masters/submaster/Course';
import Property from './components/masters/master/Property';
import Feescat from './components/masters/master/Feescat';
import Bank from './components/masters/master/Bank';
import Castecat from './components/masters/master/Castecat';
import Religion from './components/masters/master/Religion';
import Location from './components/masters/master/Location';
import Medium from './components/masters/master/Medium';
import University from './components/masters/master/University';
import Examination from './components/masters/master/Examination';
import Bankaccounts from './components/masters/master/Bankaccounts';
import Document from './components/masters/master/Document';

import Collegetype from './components/masters/submaster/Collegetype';
import Branches from './components/masters/submaster/Bracnhes';
import NextClass from './components/masters/submaster/Nextclass';
import Subjectdef from './components/masters/submaster/Sujectdef';
import Feeheads from './components/masters/submaster/Feeheads';
import Studenttype from './components/masters/submaster/Studenttype';
import Schooldetails from './components/masters/master/Schooldetails';
import Help from './panel/Help';
import Usersmgmt from './panel/Usersmgmt';
import Admissionenquiry from './components/students/Admissionenquiry';
import Admissionstud from './components/students/Admissionstud';
import Admissionprocess from './components/students/Admissionprocess';
import Students from './components/students/Students';
import Academicyear from './components/masters/master/Academicyear';
import Classalocation from './components/students/Classalocation';
import StudentProfile from './components/students/StudentProfile';
import Dailyposts from './components/masters/master/Dailyposts';
import Biometric from './components/masters/master/Biometric';
import Studentbiometric from './components/masters/master/Studentbiometric';
import FingerprintScanner from './components/masters/master/FingerprintScanner';
import Documentupload from './components/students/Documentupload';
import Teachersmgmt from './components/teachers/Teachersmgmt';
import Teachersclass from './components/teachers/Teachersclass';
import Timetable from './components/teachers/Timetable';
import Homeworkallocation from './components/teachers/Homeworkallocation';

import Addcontacts from "./components/whatsapp/Addcontacts";
import Inactivecontacts from "./components/whatsapp/Inactivecontacts";
import Createpost from "./components/whatsapp/Createpost";
import Whatsapphistory from "./components/whatsapp/Whatsapphistory";
import Contactdivion from "./components/whatsapp/Contactdivion";
import Approvals from './components/Approvals';
import Notices from './components/Notices';

import Feestructuresetuo from './components/accounts/Feestructuresetuo';
import Feecollection from './components/accounts/Feecollection';
import Expense from './components/accounts/Expense';
import Income from './components/accounts/Income';

import Books from './components/library/Books';
import Issuebooks from './components/library/Issuebooks';
import Retursbooks from './components/library/Retursbooks';
import Guestenquiry from './components/masters/master/Guestenquiry';

import Vehicalmgmt from './components/vehicals/Vehicalmgmt';
import Vehicalmaintanance from './components/vehicals/Vehicalmaintanance';
import Fuellogs from './components/vehicals/Fuellogs';
import Drivermgmt from './components/vehicals/Drivermgmt';

import Hosteldetails from './components/hostel/Hosteldetails';
import Hostelrooms from './components/hostel/Hostelrooms';
import Hostelattendance from './components/hostel/Hostelattendance';
import Roomallocation from './components/hostel/Roomallocation';
import Wardendetails from './components/hostel/Wardendetails';
import Visitorlogs from './components/hostel/Visitorlogs';

import Productcategory from './components/store/Productcategory';
import Storeproducts from './components/store/Storeproducts';
import VendorMgmt from './components/store/Vendormgmt';
import Purchaseorders from './components/store/Purchaseorders';
import StudentInventory from './components/store/Studentinventory';

import Paymentallocation from './components/payroll/Paymentallocation';
import Payslip from './components/payroll/Payslip';
import Staffattendance from './components/payroll/Staffattendance';
import Advancepayment from './components/payroll/Advancepayment';
import Monthlypayments from './components/payroll/Monthlypayments';

import Canteenstaff from './components/canteen/Canteenstaff';
import Mealplanning from './components/canteen/Mealplanning';
import Canteenmenu from './components/canteen/Canteenmenu';
import Dailyentry from './components/canteen/Dailyentry';

import Locationtype from './components/transport/Locationtype';
import Locations from './components/transport/Locations';
import Driverallotment from './components/transport/Driverallotment';
import Passentry from './components/masters/master/Passentry';
import Studentassign from './components/transport/Studentassign';
import Academiccalender from './components/masters/master/Academiccalender';
import Holidays from './components/masters/master/Holidays';
import Examtypes from './components/masters/master/Examtypes';
import Posttypes from './components/masters/master/Posttypes';
import Staffdocuments from './components/masters/submaster/Staffdocuments';
import Hostelatttiming from './components/masters/submaster/Hostelatttiming';
import Studentattendance from './components/teachers/Studentattendance';
import Feeheadclassasign from './components/masters/master/Feeheadclassasign';
import Discountypes from './components/masters/submaster/Discountypes';

import Studentoutpass from './components/reception/Studentoutpass';
import Staffoutpass from './components/reception/Staffoutpass';
import Hosteloutpass from './components/reception/Hosteloutpass';
import Studentinpass from './components/reception/Studentinpass';

import Studentwallet from './components/students/Studentwallet';
import Chat from './panel/Chat';
import Parentsmgmt from './components/students/Parentsmgmt';
import Idcardgeneration from './components/students/Idcardgeneration';
import Videmeetings from './components/Videmeetings';

import Studentreport from './components/reports/Studentreport';
import Feesreport from './components/reports/Feesreport';
import Headwisecollection from './components/reports/Headwisecollection';
import Transportreport from './components/reports/Transportreport';
import Passentriesreport from './components/reports/Passentriesreport';
import Homeworkreport from './components/reports/Homeworkreport';
import Incomeexpreport from './components/reports/Incomeexpreport';
import Vehicalmainreport from './components/reports/Vehicalmainreport';
import Storeinventory from './components/reports/Storeinventory';
import Canteenreport from './components/reports/Canteenreport';
import Staffpayreport from './components/reports/Staffpayreport';

function App() {
  const [user, setUser] = useState();

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUser(user);
    });
  });


  return (
    <div className="wrapper">
      <Router>

        {
          !user ?
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/login' element={<Login />} />
              {/* <Route path='/Register' element={<Register />} /> */}
              <Route path='/forgot-password' element={<Forgetpass />} />
            </Routes>
            :
            <>
              <Header />
              <Menu />
              <div className='content-wrapper p-3' style={{ marginBottom: 50 }}>
                <Routes>

  <Route path="/guest-enquiry" element={<Guestenquiry />} />
     <Route path="/student-hostel-inpass" element={<Studentinpass />} />
                  <Route path="/student-hostel-outpass" element={<Hosteloutpass />} />
                  <Route path="/staff-outpass" element={<Staffoutpass />} />
                  <Route path="/student-outpass" element={<Studentoutpass />} />
                   <Route path="/admission/:studentId" element={<Admissionstud />} />
                  <Route path="/admission-process" element={<Admissionprocess />} />
                  <Route path="/admission-enquiry" element={<Admissionenquiry />} />
                   <Route path='*' element={<Notfound />} />
                  <Route path='/' element={<Dashboard />} />
                  <Route path='/home' element={<Dashboard />} />
                  <Route path='/disabled-property' element={<Disabled />} />

                 
                  <Route path='/property-documents' element={<Uploaddocuments />} />
                  <Route path='/help-support' element={<Help />} />
                </Routes>

              </div>
              <Footer />
            </>
        }
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
      />
    </div >
  );
}

export default App;
